'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { ShoppingBag } from "@medusajs/icons";
import { useCart } from "@context/cart-context";
import { useCartDrawer } from "@context/cart-drawer-context";
export default function CartButton() {
  const $ = _c(11);
  const {
    itemCount
  } = useCart();
  const {
    open
  } = useCartDrawer();
  const [isHydrated, setIsHydrated] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsHydrated(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== open) {
    t2 = () => open();
    $[2] = open;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ShoppingBag className="h-5 w-5" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isHydrated || $[6] !== itemCount) {
    t4 = isHydrated && itemCount > 0 && <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-medium">{itemCount}</span>;
    $[5] = isHydrated;
    $[6] = itemCount;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <button type="button" className="relative h-10 w-10 inline-flex items-center justify-center leading-none cursor-pointer touch-manipulation text-gray-700 transition-colors active:text-black md:h-auto md:w-auto md:leading-normal" onClick={t2} data-testid="nav-cart-link" aria-label="Abrir carrito">{t3}{t4}</button>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}